import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../_services/app.service';
import { CommonService } from '../../../_services/common.service';
import { NavService } from '../../../_services/NavService.service';
import { UserService } from '../../../auth/_services';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { MobileDetectionService } from '../../services/mobile-detection.service';
import { NetworkService } from '../../services/network/network.service';
import { OrdersService } from '../../services/orders/orders.service';
import { ITableModel } from '../table/model/tableModel';
import { data } from 'jquery';
import { Helpers } from '../../../helpers';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-trip-expense',
  templateUrl: './trip-expense.component.html',
  styleUrls: ['./trip-expense.component.scss']
})
export class TripExpenseComponent implements OnInit, OnChanges {

  static that: TripExpenseComponent;
  Transporter: any = {
    lable: 'Vendor',
    formControlName: 'Transporter',
    dataField: 'Transporter',
    isRequired: true,
    placeholder: 'Select Transporter',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };
  ChargeId: any = {
    lable: 'Charges',
    formControlName: 'ChargeId',
    dataField: 'ChargeId',
    isRequired: true,
    placeholder: 'Select Charges',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };
  BasedOn: any = {
    lable: 'Unit',
    formControlName: 'BasedOn',
    dataField: 'BasedOn',
    isRequired: true,
    placeholder: 'Select BasedOn',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };
  Quantity = {
    lable: 'Quantity',
    formControlName: 'Quantity',
    dataField: 'Quantity',
    isRequired: true,
    placeholder: 'Enter Quantity',
    type: 'number'
  };
  Rate = {
    lable: 'Rate',
    formControlName: 'Rate',
    dataField: 'Rate',
    isRequired: true,
    placeholder: 'Enter Rate',
    type: 'number'
  };
  Amount = {
    lable: 'Amount',
    formControlName: 'Amount',
    dataField: 'Amount',
    isRequired: true,
    placeholder: 'Enter Amount',
    type: 'number'
  };
  Advance = {
    lable: 'Advance',
    formControlName: 'Advance',
    dataField: 'Advance',
    isRequired: false,
    placeholder: 'Enter Advance',
    type: 'number'
  };
  DeductFromAdvance: any = {
    LabelTop: "Deduct From Advance",
    dataField: 'DeductFromAdvance',
    formControlName: 'DeductFromAdvance',
    isRequired: false,
    inputValue: false
  };
  Remark = {
    lable: 'Remark',
    formControlName: 'Remark',
    dataField: 'Remark',
    isRequired: false,
    placeholder: 'Enter Remark',
    // type: 'textarea'
  };
  VehicleTypeId: any = {
    lable: 'Vehicle Type',
    formControlName: 'VehicleTypeId',
    dataField: 'VehicleTypeId',
    isRequired: false,
    placeholder: 'Select Vehicle Type',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };
  ConsignmentDetailIds: any = {
    lable: 'Consignment No',
    formControlName: 'ConsignmentDetailId',
    dataField: 'ConsignmentDetailId',
    isRequired: false,
    placeholder: 'Select consignment no',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true,
    isReadOnly:true
  };
  TenantId: any;
  CompanyId: any;
  userId: any;
  dataToSave: any = {};
  @Input() GSTType: any;
  @Input() THCId: any;
  @Input() TransporterId: any;
  tableDetails: ITableModel;
  IsAdvanceChargeCode: any = false;
  isAdvance: any = false;
  totalChargeAmount: any = 0;
  THCChargeRemark: any = '';
  totalAdvance: any = 0;
  @Output() onCloseBtnClick = new EventEmitter<any>();
  @Input() BookingId: any;
  @Input() TransporterName: any;
  @Input('VehicleTypeId') VehicleTypeIdInput: any; // Added by priya - 09/06/2026 - cn(PRIYA-JUN26-002)
  @Input() VehicleTypeName: any; // Added by priya - 09/06/2026 - cn(PRIYA-JUN26-002)
  @Input() ConsignmentDetailId: any = null;
  @Input() IndentId: any;
  isEditMode: boolean = false;
  lastSN: number = 1;
  @Input() ScreenName: any;
  @Input() ConsignmentNo: any;
  @Input() OrderNo: any;
  @Input() isOrderLevel: boolean=false;
  @Input() OrderId: any;
  imgPath: any;
  SelectedCompanyLogo: any;
  constructor(private router: Router, private route: ActivatedRoute,
    private _appService: appService, private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private translate: TranslateService,
    private commonService: CommonService,
    // private networkService: NetworkService,
    private userService: UserService,
    private _navService: NavService,
    private mobileDetectionService: MobileDetectionService,
    private modalService: NgbModal,
    private dp: DatePipe,
    private orderService: OrdersService,
  ) {
    TripExpenseComponent.that = this;
  }

  ngOnInit() {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.TenantId = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).TenantId;
    this.SelectedCompanyLogo = JSON.parse(localStorage.getItem("ChnageCompnayId")).CompanyLogoPath;
    this.imgPath = environment.apiUrl + this.SelectedCompanyLogo;
    this.DeductFromAdvance.inputValue = false;
    this.InitializeData();
    if(this.isOrderLevel === true){
      this.ConsignmentDetailIds.isReadOnly = false;
    }else{
      this.ConsignmentDetailIds.isReadOnly = true;
    }

    if(this.OrderId){
      this.thc_GetThcChargeList(this.BookingId,this.OrderId);
      this.GetConsignmentList('%%', false, true);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.TenantId = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).TenantId;
    this.InitializeData();

    if (changes['TransporterId']) {
      this.dataToSave.Transporter = this.TransporterId;
      this.dataToSave.TransporterName = this.TransporterName;
      this.GetTransporterList(this.TransporterName);
    }
    if (changes['BookingId']) {
      if(this.BookingId != null && this.BookingId != undefined)
        this.thc_GetThcChargeList(this.BookingId,null);
    }
    if (changes['ConsignmentDetailId']) {
        this.dataToSave.ConsignmentDetailId = this.ConsignmentDetailId;
        // this.dataToSave.TransporterName = this.TransporterName;
        this.GetConsignmentList(this.ConsignmentNo);
    }
    // Added by priya - 09/06/2026 - cn(PRIYA-JUN26-002)
    if (changes['VehicleTypeIdInput']) {
      this.dataToSave.VehicleTypeId = this.VehicleTypeIdInput;
      this.dataToSave.VehicleTypeName = this.VehicleTypeName;
        // this.dataToSave.TransporterName = this.TransporterName;
      this.GetVehicleTypeList(this.VehicleTypeName);
    }
    // End by priya
  }

  getChangedValue(value, data) {
    if (value) {
      if (data.dataField == 'Transporter') {
        this.dataToSave[data.dataField] = value.value;
        this.dataToSave.TransporterName = value.name;

      } else if (data.dataField == 'ChargeId') {
        this.dataToSave[data.dataField] = value.value;
        this.dataToSave.ChargeName = value.name;
        if (value.name === 'Trip Advance To Driver') {
          this.IsAdvanceChargeCode = true;
        } else {
          this.IsAdvanceChargeCode = false;
        }

      } else if (data.dataField == 'VehicleTypeId') {
        this.dataToSave[data.dataField] = value.value;
        this.dataToSave.VehicleTypeName = value.name;
      } else if (data.dataField == 'ConsignmentDetailId') {
        this.dataToSave[data.dataField] = value.value;
        this.dataToSave.ConsignmentNo = value.name;
        this.dataToSave.BookingId = value.BookingId;
        // Added by priya - 10/06/2026 - cn(PRIYA-JUN26-002)
        if (value.VehicleTypeId && value.VehicleTypeName){
          this.dataToSave.VehicleTypeId = value.VehicleTypeId;
          this.dataToSave.VehicleTypeName = value.VehicleTypeName;
          this.GetVehicleTypeList(this.dataToSave.VehicleTypeName);
          this.VehicleTypeId.isReadOnly = true;
        } else {
          this.VehicleTypeId.isReadOnly = false;
        }
        // End by priya
      } else if(data.dataField == 'BasedOn'){
        this.dataToSave[data.dataField] = value.value;
        this.CalculateChargesByUnit(value.value);
      } else {
        this.dataToSave[data.dataField] = value;
        if (data.dataField == 'Quantity' || data.dataField == 'Rate') {
          this.PopChangeData();
        }
      }
    } else{
      if(data.dataField == 'Advance'){
        this.dataToSave[data.dataField] = 0;
      }
    }
  }

  GetTransporterList(value, isScrollDown = false) {
    this.Transporter.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Transporter.dropdownList.length / 20) + 1;
    }
    this.orderService.TransporterSelect2(value, pageNo, this.TenantId).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Transporter.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Transporter.dropdownList);
        this.Transporter = { ...this.Transporter, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Transporter = { ...this.Transporter, dropdownList: [...dropdownList] });
      this.Transporter.isSearch = false;
    }).catch(error => {
      this.Transporter.isSearch = false;
    })
  }

  GetChargesList(value, isScrollDown = false) {
    this.ChargeId.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.ChargeId.dropdownList.length / 20) + 1;
    }
    this.orderService.ChargesSelect2(value, pageNo, 'Charge', this.GSTType, this.TransporterId, this.THCId ? this.THCId : null).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.ChargeId.dropdownList.length) {
        dropdownList = dropdownList.concat(this.ChargeId.dropdownList);
        this.ChargeId = { ...this.ChargeId, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.ChargeId = { ...this.ChargeId, dropdownList: [...dropdownList] });
      this.ChargeId.isSearch = false;
    }).catch(error => {
      this.ChargeId.isSearch = false;
    })
  }

  GetVehicleTypeList(value, isScrollDown = false) {
    this.VehicleTypeId.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.VehicleTypeId.dropdownList.length / 20) + 1;
    }
    this.orderService.GetSelectOrderVehicleList(value, pageNo, this.IndentId).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.VehicleTypeId.dropdownList.length) {
        dropdownList = dropdownList.concat(this.VehicleTypeId.dropdownList);
        this.VehicleTypeId = { ...this.VehicleTypeId, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.VehicleTypeId = { ...this.VehicleTypeId, dropdownList: [...dropdownList] });
      this.VehicleTypeId.isSearch = false;
    }).catch(error => {
      this.VehicleTypeId.isSearch = false;
    })
  }

   GetConsignmentList(value, isScrollDown = false,checkSingleResult = false) {
    this.ConsignmentDetailIds.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.ConsignmentDetailIds.dropdownList.length / 20) + 1;
    }
    let Type = '';
    if(this.isOrderLevel === true){
      Type = 'OrderWise'
    }else{
      Type = 'ConsignmentWise'
    }
    this.orderService.ConsignmentWiseList(value,Type,this.OrderNo, this.BookingId).then(res => {
      let dropdownList = [...res];

       if (checkSingleResult && Array.isArray(dropdownList) && dropdownList.length === 1) {
      const item = dropdownList[0];
      this.dataToSave.ConsignmentDetailId = item.value;
      this.dataToSave.ConsignmentNo = item.name;
      this.dataToSave.BookingId = item.BookingId;
    }

      if (isScrollDown && res.Total > this.ConsignmentDetailIds.dropdownList.length) {
        dropdownList = dropdownList.concat(this.ConsignmentDetailIds.dropdownList);
        this.ConsignmentDetailIds = { ...this.ConsignmentDetailIds, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.ConsignmentDetailIds = { ...this.ConsignmentDetailIds, dropdownList: [...dropdownList] });
      this.ConsignmentDetailIds.isSearch = false;
    }).catch(error => {
      this.ConsignmentDetailIds.isSearch = false;
    })
  }

  InitializeData() {
    this.tableDetails = {
      data: [],
      emptyDataMSg: "No Records Found",
      columnDetails: [
        { columnName: "Vendor", dataFieldName: "VendorName", },
        { columnName: "Charge", dataFieldName: "chrgerCode", },
        { columnName: "Based On", dataFieldName: "Unit", },
        { columnName: "Qty", dataFieldName: "Qty",alignType:'right' },
        { columnName: "Rate", dataFieldName: "Rate",alignType:'right' },
        { columnName: 'Amount', dataFieldName: 'totalAmount',alignType:'right',divType:'toshowvaluewithDecimals' },
        { columnName: "Advance", dataFieldName: "Advance",alignType:'right',divType:'toshowvaluewithDecimals' },
        { columnName: "Deduct From Advance", dataFieldName: "DeductFromAdvanceValue" },
        { columnName: "Vehicle Type", dataFieldName: "VehicleTypeName" },
        { columnName: "Actions", dataFieldName: "actions", divType: "TyreAssignaction" },
      ],
      footerData: [
        { VendorName: 'Total', chrgerCode: '', Unit: '', Qty: '', Rate: '', totalAmount: '0', Advance: '0', DeductFromAdvanceValue: '' },
      ],
      actionList: [
        {
          label: 'Edit', command: (event?: any) => console.log(event)
        },
        { label: 'Delete', }],
      isColumnNameShow: true,
      isShowFooterData: true,
    };
  }

  PopChangeData() {
    if (
      this.dataToSave.Discount == "undefined" ||
      this.dataToSave.Discount == null
    ) {
      this.dataToSave.Discount = 0;
    } else {
      this.dataToSave.Discount = parseFloat(this.dataToSave.Discount)
    }
    if (this.dataToSave.Rate == "undefined" || this.dataToSave.Rate == null) {
      this.dataToSave.Rate = 0;
    } else {
      this.dataToSave.Rate = parseFloat(this.dataToSave.Rate)
    }
    if (
      this.dataToSave.Quantity == "undefined" ||
      this.dataToSave.Quantity == null
    ) {
      this.dataToSave.Quantity = 0;
    } else {
      this.dataToSave.Quantity = parseFloat(this.dataToSave.Quantity);
    }
    this.dataToSave.Amount = (this.dataToSave.Rate * this.dataToSave.Quantity) - this.dataToSave.Discount;
    this.dataToSave.Amount = parseFloat(this.dataToSave.Amount).toFixed(2);

    if (this.IsAdvanceChargeCode) {
      this.dataToSave.Advance = this.dataToSave.Amount;
    }

    //add by maaria
    if (this.dataToSave.Advance == "undefined" || this.dataToSave.Advance == null) {
      this.dataToSave.Advance = 0;
    } else {
      if (this.dataToSave.Advance > this.dataToSave.Amount) {
        this.isAdvance = true;
      }
      else {
        this.isAdvance = false;
        this.dataToSave.Advance = parseFloat(this.dataToSave.Advance);
      }

    }
    //end
  }

  onActionClick({ row, actionName }) {
    if (actionName.trim() == 'Edit') {
      this.isEditMode = true;
      this.dataToSave = {};
      this.dataToSave = row;
      this.dataToSave.Transporter = row.VendorId;
      this.dataToSave.TransporterName = row.VendorName;
      this.dataToSave.ChargeName = row.chrgerCode;
      this.dataToSave.Quantity = row.Qty;
      this.dataToSave.Amount = row.totalAmount;
      this.dataToSave.BasedOn = row.Unit;
      this.dataToSave.Rate = row.Rate;
      this.dataToSave.DeductFromAdvance = row.DeductFromAdvanceValue == 'Yes' ? true : false;
      this.dataToSave.DeductFromAdvanceValue = row.DeductFromAdvanceValue;
      this.DeductFromAdvance.inputValue = this.dataToSave.DeductFromAdvance;
      this.dataToSave.Charge = row.Charge;
      this.dataToSave.Remark = row.THCChargeRemark ? row.THCChargeRemark : row.Remark;
      this.dataToSave.VehicleTypeId = row.VehicleTypeId;
      this.dataToSave.VehicleTypeName = row.VehicleTypeName;
      this.dataToSave.ChargeId = row.ChargeId !=null ? row.ChargeId : row.Charge;
      this.ChargeId.dropdownList=[];
      var obj:any ={};
      obj.value = this.dataToSave.ChargeId != null ? this.dataToSave.ChargeId : this.dataToSave.Charge;
      obj.name =this.dataToSave.ChargeName;
      this.ChargeId.dropdownList.push(obj);

      //added by fahim 12-01-2026 :)
      this.BasedOn.dropdownList=[];
      var obj1:any ={};
      obj1.value = this.dataToSave.BasedOn;
      obj1.name =this.dataToSave.BasedOn;
      this.BasedOn.dropdownList.push(obj1);
      //End added by fahim 12-01-2026 :)

      this.GetTransporterList(row.VendorName);
      // this.GetChargesList(row.chrgerCode);
      this.GetVehicleTypeList(row.VehicleTypeName);

      // let indexToRemove = this.tableDetails.data.findIndex(record => record.SN === row.SN);
      let indexToRemove = this.tableDetails.data.findIndex(record => 
        (row.SN != null && record.SN === row.SN) ||
        (row.SN == null && record.Id === row.Id)
      );

      if (indexToRemove !== -1) {
        this.tableDetails.data.splice(indexToRemove, 1);
        this.CalcFooterValue();
      }
    } else if (actionName.trim() == 'Delete') {
      // let indexToRemove = this.tableDetails.data.findIndex(record => record.SN === row.SN);
      if (row.Id == null) {
        let indexToRemove = this.tableDetails.data.findIndex(record => 
          (row.SN != null && record.SN === row.SN) ||
          (row.SN == null && record.Id === row.Id)
        );
        this.RemoveIncome(indexToRemove);
      } else {
        this.DeleteCharge(row.Id);
      }
    }
  }

  RemoveIncome(index) {
    return new Promise((resolve) => {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, {
        centered: true,
      });
      dialogRef.componentInstance.details = {
        message: "Are you sure you want to remove this record?",
        title: "Confirmation",
      };
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {
          TripExpenseComponent.that.tableDetails.data.splice(
            index,
            1
          );
          TripExpenseComponent.that.CalcFooterValue();
        }
        dialogRef.close();
      });
    });
  }

  isFormSubmit: boolean = false;
  addChargeinAmount() {
    this.isFormSubmit = true;
    if (!this.dataToSave.Transporter) {
      this.toastr.error('Select Vendor!', 'Error');
      return false;
    }
    if (!this.dataToSave.ChargeId) {
      this.toastr.error('Select Charges!', 'Error');
      return false;
    }
    if (!this.dataToSave.BasedOn) {
      this.toastr.error('Select Based On!', 'Error');
      return false;
    }

    if (this.dataToSave.Amount != 0) {
      var obj: any = {};
      obj.VendorId = this.dataToSave.Transporter;
      obj.VendorName = this.dataToSave.TransporterName;
      obj.chrgerCode = this.dataToSave.ChargeName;
      obj.Unit = this.dataToSave.BasedOn;
      obj.Qty = this.dataToSave.Quantity;
      obj.Rate = this.dataToSave.Rate ? parseFloat(this.dataToSave.Rate).toFixed(2) : this.dataToSave.Rate;
      // obj.totalAmount = this.dataToSave.Amount ? parseFloat(this.dataToSave.Amount).toFixed(2) : this.dataToSave.Amount;
      // obj.Advance = this.dataToSave.Advance ? parseFloat(this.dataToSave.Advance).toFixed(2) : this.dataToSave.Advance;
      const amount = Number(this.dataToSave.Amount);
      const advance = Number(this.dataToSave.Advance);
      obj.totalAmount = !isNaN(amount) ? Number(amount.toFixed(2)) : 0;
      obj.Advance    = !isNaN(advance) ? Number(advance.toFixed(2)) : 0;
      obj.ContractAmount = 0;
      obj.IsContracted = 'false';
      obj.DeductFromAdvanceValue = this.dataToSave.DeductFromAdvance == true ? 'Yes' : 'No';
      obj.DeductFromAdvance = this.dataToSave.DeductFromAdvance;
      // obj.SN = this.tableDetails.data ? (this.tableDetails.data.length + 1) : 1;
      obj.Charge = this.dataToSave.ChargeId;
      obj.THCChargeRemark = this.dataToSave.Remark;
      obj.VehicleTypeId = this.dataToSave.VehicleTypeId;
      obj.VehicleTypeName = this.dataToSave.VehicleTypeName;
      obj.Id = this.dataToSave.Id !== undefined ? this.dataToSave.Id : null;
      obj.SN = this.lastSN;
      this.lastSN++;
      if(this.isOrderLevel === true){
        obj.BookingId = this.dataToSave.BookingId;
        obj.ConsignmentDetailId = this.dataToSave.ConsignmentDetailId;
        obj.ConsignmentNo = this.dataToSave.ConsignmentNo;
        obj.UserId = this.userId;;
      }
      this.tableDetails.data.push(obj);

      this.IsAdvanceChargeCode = false;
      this.totalChargeAmount = 0;
      this.totalAdvance = 0;

      this.dataToSave = {};
      this.isFormSubmit = false;
      this.dataToSave.DeductFromAdvance = false;
      this.DeductFromAdvance.inputValue = false;
      this.CalcFooterValue();
      this.isEditMode = false;
    } else {
      this.toastr.error("Amount is zero !", "error");
    }
  }

  CalcFooterValue() {
    var sumofTotal = 0;
    var sumofAdvance = 0;
    this.tableDetails.data.forEach(element => {
      sumofTotal += parseFloat(element.totalAmount);
      sumofAdvance += parseFloat(element.Advance);
    });

    setTimeout(() => {
      this.tableDetails.footerData[0].Advance = parseFloat(sumofAdvance.toString()).toFixed(2);
      this.tableDetails.footerData[0].totalAmount = parseFloat(sumofTotal.toString()).toFixed(2);
    }, 500);
  }

  closeModal() {
    this.onCloseBtnClick.emit();
  }

  SaveTripExpense() {
    Helpers.setLoading(true);
    if(this.isOrderLevel === false){
      this.tableDetails.data.forEach((element) => {
        element.BookingId = this.BookingId;
        element.UserId = this.userId;
        element.ConsingmentDetailId = this.ConsignmentDetailId;
      });
    }

    setTimeout(() => {
      if (this.tableDetails.data.length == 0) {
        this._appService
          .GetByThreeId(
            "Booking",
            "td_deleteTripChargesV2",
            this.BookingId,
            this.userId,
            this.ConsignmentDetailId
          )
          .subscribe(
            async (response) => {
              this.closeModal();
              Helpers.setLoading(false);
            },
            async (err) => {
              Helpers.setLoading(false);
              this.toastr.error(err._body.replace(/"/g, ""), "error");
            }
          );
      } else {
        this._appService
          .Post(
            "Booking",
            "td_saveTripChargesV2",
            this.tableDetails.data
          )
          .subscribe(
            async (response) => {
              this.toastr.success('Data saved successfuly!', 'Ok');
              this.closeModal();
              Helpers.setLoading(false);
            },
            async (err) => {
              this.toastr.error('Failed to save data!', 'Error')
              Helpers.setLoading(false);
              this.toastr.error(err._body.replace(/"/g, ""), "error");
            }
          );
      }
    }, 500);
  }

  DeleteCharge(Id) {
    return new Promise((resolve) => {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, {
        centered: true,
      });
      dialogRef.componentInstance.details = {
        message: "Are you sure you want to remove this record?",
        title: "Confirmation",
      };
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {
          TripExpenseComponent.that._appService.GetByIdparam('byVehicleIncome','DeleteVehicleDispatchedCharges',Id,this.userId).subscribe(
            (response) => {
              TripExpenseComponent.that.CalcFooterValue();
              this.thc_GetThcChargeList(this.BookingId,null);
            },
            (error)=>{
              TripExpenseComponent.that.toastr.error(
                error._body.replace(/"/g, ""),
                "error"
              );
            }
          );

          // TripExpenseComponent.that.tableDetails.data.splice(
          //   index,
          //   1
          // );
        }
        dialogRef.close();
      });
    });
  }

  thc_GetThcChargeList(bookingId,IndentId) {
    Helpers.setLoading(true);
    this._appService
      .GetByFourId(
        "OrdersByVehicle",
        "tmsApp_getTHCChargeListV2",
        bookingId,
        this.CompanyId,
        this.ConsignmentDetailId,
        IndentId
      )
      .subscribe(
        async (response) => {
          this.tableDetails.data = [];
          this.tableDetails.data = response;
           const hasConsignmentNo = this.tableDetails.data.some(item => item.ConsignmentNo !== undefined);
           if (hasConsignmentNo) {
            const alreadyExists = this.tableDetails.columnDetails.some(
              col => col.dataFieldName === "ConsignmentNo"
            );

            if (!alreadyExists) {
              this.tableDetails.columnDetails.splice(0, 0, {
                columnName: "Consignment No",
                dataFieldName: "ConsignmentNo"
              });

              // Also update footerData if necessary (optional)
              this.tableDetails.footerData.forEach(row => {
                row["ConsignmentNo"] = "";
              });
            }
          }
          this.CalcFooterValue();
          Helpers.setLoading(false);
        },
        async (err) => {
          Helpers.setLoading(false);
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        }
      );
  }

  ExpenseVoucherData: any = [];
  printExpenseVoucher() {

    this._appService
      .GetByThreeId("Booking", "td_getTripExpenseVoucherDataV2", this.BookingId, this.userId, this.ConsignmentDetailId)
      .subscribe(
        (response) => {
          var tab1: any = [];
          tab1 = response.Table;
          if (tab1.length > 0) {
            this.ExpenseVoucherData = response.Table;
            this.ExpenseVoucherData[0].chargeList = [];
            var tab2: any = [];
            tab2 = response.Table1;
            if (tab2.length > 0) {
              this.ExpenseVoucherData[0].chargeList = response.Table1;
              this.ExpenseVoucherData[0].TotalChargeAmount = 0;
              this.ExpenseVoucherData[0].chargeList.forEach((element) => {
                this.ExpenseVoucherData[0].TotalChargeAmount =
                  this.ExpenseVoucherData[0].TotalChargeAmount + element.Amount;
              });
            }
          }

          setTimeout(() => {
            var divElements = document.getElementById("PrintExpenseVoucher");
            var $iframe: any = $("<iframe>").appendTo("body");
            var printDiv =
              "<html><head><title> Expense Voucher </title></head><body>" +
              divElements.innerHTML +
              "</body></html>";
              console.log('PrintExpenseVoucher',divElements.innerHTML);
            $iframe.contents().find("body").html(printDiv);
            var win = $iframe[0].contentWindow || $iframe[0];
            win.window.print();
            $iframe.remove();
          }, 1000);
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        }
      );
  }

  //added by fahim (12-01-2026)
  GetNewUnitsList(value, isScrollDown = false) {
    this.BasedOn.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.BasedOn.dropdownList.length / 20) + 1;
    }
    this.orderService.GetNewUnitsList(value).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.BasedOn.dropdownList.length) {
        dropdownList = dropdownList.concat(this.BasedOn.dropdownList);
        this.BasedOn = { ...this.BasedOn, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.BasedOn = { ...this.BasedOn, dropdownList: [...dropdownList] });
      this.BasedOn.isSearch = false;
    }).catch(error => {
      this.BasedOn.isSearch = false;
    })
  }

  CalculateChargesByUnit(ChargesPer){
    let obj:any={};
    obj.OrderId=this.BookingId;
    obj.NetworkId=null;
    obj.ChargesPer=ChargesPer;
    obj.UnitRate=0;
    this._appService.Post('OrdersByVehicle','CalculateChargesByUnit',obj).subscribe(
      (response)=>{
        if(response && response.length>0){
          console.log(response[0].Qty);
          const newQTY = response[0].Qty
          this.dataToSave.Quantity=newQTY;
          // this.dataToSave.Amount = this.dataToSave.Rate * this.dataToSave.Quantity 
          this.dataToSave.Amount = (this.dataToSave.Rate != null ? this.dataToSave.Rate : 0) * (this.dataToSave.Quantity != null ? this.dataToSave.Quantity : 0);
          console.log('this.dataToSave.Quantity',this.dataToSave.Quantity);
        }
      },
      (error)=>{
        this.toastr.error('Error while calculating qty','Error');
      }
    );
  }

  //End added by fahim 12-01-2026 :)
}
